(function() {
	'use strict';
	angular.module('app.shell').directive('edFooterInternal', edFooterInternal);

	function edFooterInternal() {
		var directive = {
			// controller: ['$scope', '$rootScope', controller],
			templateUrl: '/app/content/footer/edFooterInternal.html',
			// restrict: 'EA',
			// scope: {}
		};

		return directive;

		// function controller($scope, $rootScope) {
		// 	$scope.lang = $rootScope.lang;
		// }
	}
})();
